/**
 * Remembers that the user has just replaced their card, so the past-due seat-pack banner can say
 * "we'll retry the charge" instead of repeating an alarm that invites a second card entry.
 *
 * sessionStorage rather than redux on purpose: entering a card is exactly the moment someone
 * reloads the page, and a redux flag would be gone when the reassurance is needed most. Session
 * scope also means it can never outlive the problem it describes.
 *
 * Set by PaymentDetailsTab, read by SeatPackPastDueBanner (which clears it once the rows come back
 * clean) — the two are far enough apart in the tree that passing a prop would thread through the
 * whole account modal.
 */

const CARD_UPDATED_KEY = "seat_packs_card_updated";

export const markCardUpdatedForRetry = (): void => {
  try {
    sessionStorage.setItem(CARD_UPDATED_KEY, "1");
  } catch (error) {
    // Storage can be unavailable (private mode, blocked cookies) — the banner just keeps its
    // original wording, which is still correct.
  }
};

export const wasCardUpdatedForRetry = (): boolean => {
  try {
    return sessionStorage.getItem(CARD_UPDATED_KEY) === "1";
  } catch (error) {
    return false;
  }
};

export const clearCardUpdatedForRetry = (): void => {
  try {
    sessionStorage.removeItem(CARD_UPDATED_KEY);
  } catch (error) {
    // Nothing to do — see markCardUpdatedForRetry.
  }
};
